import { Routes, Route, Navigate } from 'react-router-dom'
import { gql } from 'graphql-request'
import { User, Users, Building2 } from 'lucide-react'

import { useQuery } from '@hooks/graphql'
import VerticalNavTabs from '@components/VerticalNavTabs'
import Spinner from '@components/Spinner'
import { useCurrentUser } from '@contexts/currentUser'
import Breadcrumbs from '@components/Breadcrumbs'

import EducatorList from './EducatorList'
import StudentList from './StudentList'
import Profile from './Profile'

const ORGANIZATION_QUERY = gql`
  query organization {
    organization {
      id
      name
      organizationType
      moderationPolicy
    }
  }
`

const Organization = () => {
  const { currentMembership: { role, organization: currentOrganization } } = useCurrentUser()
  const isEducatorAdmin = role === 'admin'
  const customModerationEnabled = currentOrganization.features.includes('moderation_v2')

  const { isLoading, refetch, data: { organization = {} } = {} } = useQuery({
    queryKey: ['organization'],
    gqlQuery: ORGANIZATION_QUERY,
    enabled: isEducatorAdmin
  })

  if (isEducatorAdmin && isLoading) {
    return <Spinner className='relative top-0 left-0 flex items-center justify-center w-full h-screen' />
  }

  return (
    <div className='h-full'>
      <Breadcrumbs>
        <Breadcrumbs.Text label='Organization' />
      </Breadcrumbs>

      <div className='flex flex-col md:flex-row h-[calc(100vh-64px)]'>
        <VerticalNavTabs>
          <If condition={isEducatorAdmin}>
            <VerticalNavTabs.Link to='profile' label='Profile' icon={<Building2 size={16} />} />
          </If>

          <VerticalNavTabs.Link to='educators' label='Educators' icon={<User size={16} />} />

          <If condition={isEducatorAdmin}>
            <VerticalNavTabs.Link to='students' label='Students' icon={<Users size={16} />} />
          </If>
        </VerticalNavTabs>

        <div className='grow p-5'>
          <Routes>
            <Route path='/' element={<Navigate to='educators' />} />

            <If condition={isEducatorAdmin}>
              <Route
                path='profile'
                element={
                  <Profile
                    organizationId={organization.id}
                    name={organization.name}
                    organizationType={organization.organizationType}
                    moderationPolicy={organization.moderationPolicy}
                    customModerationEnabled={customModerationEnabled}
                    refetch={refetch}
                  />
                }
              />
            </If>

            <Route path='educators' element={<EducatorList />} />

            <If condition={isEducatorAdmin}>
              <Route path='students' element={<StudentList />} />
            </If>
          </Routes>
        </div>
      </div>
    </div>
  )
}

export default Organization
